import { HubConnectionProvider } from "../context/HubConnectionContext";

export const HubConnection= (props) => {
	

	return <HubConnectionProvider>{props.children}</HubConnectionProvider>;
};